import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("i", { class: "pi pi-chevron-left mr-1" }, null, -1)
const _hoisted_2 = { class: "mt-2" }
const _hoisted_3 = { class: "groups-tabview" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_CommandGroup = _resolveComponent("CommandGroup")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_Button = _resolveComponent("Button")
  const _component_TabView = _resolveComponent("TabView")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", null, [
      _createVNode("div", null, [
        _createVNode(_component_router_link, {
          to: _ctx.backLink,
          class: "fs-18 text-decoration-none text-gray"
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("general.backTo")) + ": " + _toDisplayString(_ctx.currentPlant.name), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("AppResource.GeneralCommandsAndGroups")), 1)
      ])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_TabView, {
        class: "p-tabview--custom",
        activeIndex: _ctx.activeTabIndex,
        "onUpdate:activeIndex": _cache[8] || (_cache[8] = ($event: any) => (_ctx.activeTabIndex = $event)),
        onTabChange: _ctx.tabChanged
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, {
            header: _ctx.$t('AppResource.GeneralCommands')
          }, {
            default: _withCtx(() => [
              (_ctx.commands.length > 0)
                ? (_openBlock(), _createBlock(_component_ElScrollbar, {
                    key: 0,
                    class: "groups-card-list"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.commands[0])
                        ? (_openBlock(), _createBlock(_component_CommandGroup, {
                            key: 0,
                            "command-group": _ctx.commands[0],
                            onEdit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleEditCommandGroup(_ctx.commands[0]))),
                            onDelete: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleDeleteCommandGroup(_ctx.commands[0]))),
                            "disable-actions": !_ctx.commandsAndGroupsGroupActionsEnabled,
                            onAdd: _cache[3] || (_cache[3] = ($event: any) => (
                                _ctx.handleCreateGroup(
                                    _ctx.AggregateCommandType.General,
                                    _ctx.commands[0].roomObjectType
                                )
                            ))
                          }, null, 8, ["command-group", "disable-actions"]))
                        : _createCommentVNode("", true),
                      (_ctx.commands[1])
                        ? (_openBlock(), _createBlock(_component_CommandGroup, {
                            key: 1,
                            "command-group": _ctx.commands[1],
                            onEdit: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleEditCommandGroup(_ctx.commands[1]))),
                            onDelete: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleDeleteCommandGroup(_ctx.commands[1]))),
                            "disable-actions": !_ctx.commandsAndGroupsGroupActionsEnabled,
                            onAdd: _cache[6] || (_cache[6] = ($event: any) => (
                                _ctx.handleCreateGroup(
                                    _ctx.AggregateCommandType.General,
                                    _ctx.commands[1].roomObjectType
                                )
                            ))
                          }, null, 8, ["command-group", "disable-actions"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_TabPanel, {
            header: _ctx.$t('AppResource.Groups')
          }, {
            default: _withCtx(() => [
              (_ctx.commandsAndGroupsAddGroupEnabled)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleCreateGroup(_ctx.AggregateCommandType.Group))),
                    class: "p-button-rounded p-button-raised p-button--m ml-2 button-add-group"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("plantDetail.addGroup")), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.groups.length > 0)
                ? (_openBlock(), _createBlock(_component_ElScrollbar, {
                    key: 1,
                    class: "groups-card-list"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.groups, (g, i) => {
                        return (_openBlock(), _createBlock(_component_CommandGroup, {
                          key: `command-group-${i}`,
                          "command-group": g,
                          onEdit: ($event: any) => (_ctx.handleEditCommandGroup(g)),
                          onDelete: ($event: any) => (_ctx.handleDeleteCommandGroup(g)),
                          "disable-actions": !_ctx.commandsAndGroupsGroupActionsEnabled
                        }, null, 8, ["command-group", "onEdit", "onDelete", "disable-actions"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      }, 8, ["activeIndex", "onTabChange"])
    ])
  ], 64))
}